import { render } from "./CustomFieldsModal.vue?vue&type=template&id=58e6e8e0&scoped=true"
import script from "./CustomFieldsModal.vue?vue&type=script&lang=js"
export * from "./CustomFieldsModal.vue?vue&type=script&lang=js"

import "./CustomFieldsModal.vue?vue&type=style&index=0&id=58e6e8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e6e8e0"]])

export default __exports__